/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import _0x186a09 from'./sessioncollection.js';export default class Sessions{static async['getConnectedSessions'](_0x2f7a77,_0x31d538,_0x1dbffd){const _0x32edb8=new _0x186a09(_0x31d538,_0x1dbffd);return await _0x32edb8['connect'](_0x2f7a77),_0x32edb8;}}